import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { trans } from '@spotahome/bff/client';

import mapPointShape from '../../../../pages/search/shapes/mapPoint';
import PlacesAutocomplete from '../../ui/map/places-autocomplete';

class ContextBar extends PureComponent {
  static propTypes = {
    area: PropTypes.shape({
      id: PropTypes.string.isRequired,
      center: PropTypes.shape(mapPointShape).isRequired
    }).isRequired,
    pointOfInterest: PropTypes.object,
    onPlaceSelected: PropTypes.func,
    onPlaceUnselected: PropTypes.func,
    countryCode: PropTypes.string
  };

  render() {
    const ContextBarClassName = classNames(
      'search-context',
      this.props.className
    );

    return (
      <div className={ContextBarClassName} data-cy="map-search-bar">
        <div className="search-autocomplete">
          <PlacesAutocomplete
            boundCoords={this.props.area.center}
            boundRadius={500}
            inputId={'searchMapInput'}
            placeholder={trans('rentable_unit_map.autocomplete.placeholder')}
            pointOfInterest={this.props.pointOfInterest}
            onPlaceSelected={this.props.onPlaceSelected}
            onPlaceUnselected={this.props.onPlaceUnselected}
            areaSlug={this.props.area.id}
            countryCode={this.props.countryCode}
          />
        </div>
      </div>
    );
  }
}

export default ContextBar;
